import { render, staticRenderFns } from "./couponCategory.vue?vue&type=template&id=41fae375&scoped=true&"
import script from "./couponCategory.vue?vue&type=script&lang=js&"
export * from "./couponCategory.vue?vue&type=script&lang=js&"
import style0 from "./couponCategory.vue?vue&type=style&index=0&id=41fae375&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fae375",
  null
  
)

export default component.exports